export const SEARCH_ENTITY_SERVICES_REQUEST = "SEARCH_ENTITY_SERVICES_REQUEST";
export const SEARCH_ENTITY_SERVICES_SUCCESS = "SEARCH_ENTITY_SERVICES_SUCCESS";
export const SEARCH_ENTITY_SERVICES_FAILED = "SEARCH_ENTITY_SERVICES_FAILED";
export const PAGINATE_SEARCH_ENTITY_SERVICES =
  "PAGINATE_SEARCH_ENTITY_SERVICES";
